import React, { FunctionComponent } from 'react';
import Page from '@/components/layout/Page';
import LandingPageLinkIndex from '@/components/landingPages/LandingPageLinkIndex';
import Header from '@/components/typography/Header';
import { ILandingPageLink } from '@/pageGeneration/services/LandingPageService';

interface IProps {
  items: ILandingPageLink[];
  title: string;
}

const DestinationRegionPage: FunctionComponent<IProps> = ({ items, title }) => (
  <Page>
    <Header level={1} style={{ fontSize: 44 }}>
      {title}
    </Header>
    <LandingPageLinkIndex items={items} />
  </Page>
);

export default DestinationRegionPage;
